import { ReactComponent as HideIcon } from "./assets/hideIcon.svg";
import { likeCard } from "@/utils/net";
import { taskDetailAtom, cardsAtom } from "@/store";
import { useRecoilState } from "recoil";

const HideCard = () => {
  const [taskDetail, setTaskDetail] = useRecoilState<{
    task_uuid;
    is_hidden;
    author;
  }>(taskDetailAtom);
  const [cards, setCards] = useRecoilState<{
    task_uuid: string
    is_hidden: boolean;
  }[]>(cardsAtom);
  const { task_uuid, is_hidden, author } = taskDetail;
  const isMe = author?.user_uuid === localStorage.getItem("user_uuid");

  if (!isMe) {
    return null;
  }

  const handleLikeClick = async () => {
    const index = cards.findIndex((item) => item.task_uuid === task_uuid);
    if (index > -1) {
      const card = {
        ...cards[index],
        is_hidden: !cards[index].is_hidden
    };
    setCards([...cards.slice(0,index), card, ...cards.slice(index + 1)],);
    }
    setTaskDetail((pre) => {
      return {
        ...pre,
        is_hidden: !pre.is_hidden,
      };
    });
    likeCard({ task_uuid, operation: is_hidden ? "Unhide" : "Hide" });
  };
  return (
    <button
      onClick={() => handleLikeClick()}
      className={`w-12 h-12 rounded-xl active:scale-95 ml-4 transition-300-ease backdrop-blur cursor-pointer 2 flex-center ${
        is_hidden
          ? "text-[#0590DF] bg-[rgba(5,144,223,0.15)] hover:bg-[rgba(5,144,223,0.25)]"
          : "bg-[#F8F8F8] text-[#D0D0D0] hover:text-[#B5B5B5] hover:bg-[#F0F0F0]"
      }`}
    >
      <HideIcon />
    </button>
  );
};

export default HideCard;
